import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import UserAuthenticationLogin from './UserAuthenticationLogin';
import UserAuthenticationResetPassword from './UserAuthenticationResetPassword';

const UserAuthentication = (props) => {
  const [stage, setStage] = React.useState('LOGIN');
  const [userData, setUserData] = React.useState(null);

  const userForgotPassword = props.userForgotPassword;
  if (stage === 'LOGIN') {
    return (
      <UserAuthenticationLogin
        userForgotPassword={userForgotPassword}
        resetPassword={(e) => {
          setUserData(e);
          setStage('RESET');
        }}
      />
    );
  } else if (stage === 'RESET') {
    return (
      <UserAuthenticationResetPassword
        userData={userData}
      />
    );
  } else {
    return null;
  }
};

UserAuthentication.propTypes = {
  statusProgressWrap: PropTypes.func.isRequired,
  userLogin: PropTypes.func.isRequired,
  userForgotPassword: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(UserAuthentication));
